import React from 'react';
import PropTypes from 'prop-types';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import IllustrationBadge from '@deliveroo/consumer-component-library/components/IllustrationBadge';
import classnames from 'classnames';

import styles from './styles.scss';
/**
 * Used to render error messaging for the Home results summary.
 */
const ResultsSummaryError = ({ errorData, loading, isSearchResults }) => {
  if (!errorData) return null;
  const { type, title, message, buttonText, buttonAction, imageUrl } = errorData;
  let badgeName;

  if (!imageUrl) {
    if (['service-advisory', 'no-restaurants'].includes(type)) {
      badgeName = 'rider-bicycle';
    } else if (type === 'server-error') {
      badgeName = 'problem-1';
    } else {
      badgeName = 'plate-empty';
    }
  }

  const wrapperClasses = classnames(styles.errorWrapper, {
    [styles.isSearchResults]: isSearchResults,
  });

  return (
    <div className={wrapperClasses}>
      <span className={styles.image}>
        {imageUrl ? (
          <BackgroundImage src={imageUrl} />
        ) : (
          <IllustrationBadge name={badgeName} size={88} />
        )}
      </span>
      <Heading level={3} color="black" size="small" spacing="small 0">
        {title}
      </Heading>
      <P color="grey" size="small" spacing="small 0">
        {message}
      </P>
      {buttonText && (
        <Button
          type="primary"
          spacing="small 0"
          size="small"
          onClick={buttonAction}
          isLoading={loading}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

ResultsSummaryError.propTypes = {
  errorData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    buttonAction: PropTypes.func,
    imageUrl: PropTypes.string,
  }),
  loading: PropTypes.bool,
  isSearchResults: PropTypes.bool,
};

ResultsSummaryError.defaultProps = {
  errorData: undefined,
  loading: false,
  isSearchResults: false,
};

export default ResultsSummaryError;
